import { render, staticRenderFns } from "./ConventionCa.vue?vue&type=template&id=48b3fea4&scoped=true"
import script from "./ConventionCa.vue?vue&type=script&lang=js"
export * from "./ConventionCa.vue?vue&type=script&lang=js"
import style0 from "./ConventionCa.vue?vue&type=style&index=0&id=48b3fea4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b3fea4",
  null
  
)

export default component.exports